<template>
    <el-dialog
        :visible.sync="visible"
        title="订货单速览"
        width="92%"
        top="4vh"
        append-to-body
        destroy-on-close
        :close-on-click-modal="false"
        @close="handleClose"
    >
        <div>
            <div v-if="rows && rows.length > 0" :style="{ marginBottom: '12px', fontSize: '14px' }">
                合计金额汇总：<span :style="{ fontWeight: 'bold' }">{{ $lodash.toMoney(totalMoneySum) }}</span>
            </div>
            <el-empty v-if="!rows || rows.length === 0" description="暂无订货单行" />
            <vxe-table
                v-else
                :data="rows"
                border
                stripe
                show-overflow
                max-height="560"
            >
                <vxe-column min-width="130" fixed="left" title="订单号">
                    <template #default="{ row }">
                        <span class="el-span-primary" @click="handleOpenOrder(row)">{{ orderNumber(row) }}</span>
                    </template>
                </vxe-column>
                <vxe-column min-width="200" fixed="left" title="供应商">
                    <template #default="{ row }">
                        <el-span type="primary" @click.native="handleOpenSupplier(row)" :title="row.product?.supplier?.name" />
                    </template>
                </vxe-column>
                <vxe-column min-width="120" fixed="left" title="产品名称">
                    <template #default="{ row }">
                        <el-span type="primary" @click.native="handleOpenProduct(row)" :title="row.product?.name" />
                    </template>
                </vxe-column>
                <vxe-column min-width="100" field="product.type.name" title="产品类别"></vxe-column>
                <vxe-column min-width="100" field="product.brand" title="产品品牌"></vxe-column>
                <vxe-column min-width="200" title="规格参数">
                    <template #default="{ row }">
                        {{ row.product?.parameter?.toString() }}
                    </template>
                </vxe-column>
                <vxe-column min-width="100" title="采购数量">
                    <template #default="{ row }">
                        {{ row.num }} / {{ row.product?.unit }}
                    </template>
                </vxe-column>
                <vxe-column min-width="110" title="采购日期">
                    <template #default="{ row }">
                        {{ row.product_order.date }}
                    </template>
                </vxe-column>
                <vxe-column min-width="110" title="订单创建人">
                    <template #default="{ row }">
                        {{ row.product_order.created_user?.name ?? '-'}}
                    </template>
                </vxe-column>
                <vxe-column min-width="90" field="pay_date" title="付款日期"></vxe-column>
                <vxe-column min-width="90" field="pay_type.name" title="付款方式"></vxe-column>
                <vxe-column min-width="90" field="taxation_rate" title="发票税率"></vxe-column>
                <vxe-column min-width="90" field="arrive_date" title="到货周期"></vxe-column>
                <vxe-column min-width="90" title="采购单价">
                    <template #default="{ row }">
                        {{ $lodash.toMoney(row.money) }}
                    </template>
                </vxe-column>
                <vxe-column min-width="100" title="合计金额">
                    <template #default="{ row }">
                        {{ $lodash.toMoney(row.money_total) }}
                    </template>
                </vxe-column>
                <vxe-column min-width="90" field="product.maintenance" title="保修期"></vxe-column>
                <vxe-column min-width="160" field="describe" title="备注说明"></vxe-column>
                <vxe-column min-width="80" title="折扣">
                    <template #default="{ row }">
                        {{ row.discount }} %
                    </template>
                </vxe-column>
                <vxe-column min-width="90" title="整单折扣">
                    <template #default="{ row }">
                        {{ row.discount_document }} %
                    </template>
                </vxe-column>
                <vxe-column min-width="100" title="整单折后价">
                    <template #default="{ row }">
                        {{ $lodash.toMoney(row.money_discount) }}
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            rows: [],
        }
    },
    computed: {
        totalMoneySum() {
            if (!this.rows || this.rows.length === 0) {
                return 0
            }
            return this.rows.reduce((sum, row) => {
                const n = Number(row.money_total)
                return sum + (Number.isFinite(n) ? n : 0)
            }, 0)
        },
    },
    methods: {
        /**
         * @param {Object} config
         * @param {Array} config.rows 已由父组件从采购单列表展平并附带 product_order  的行数据
         */
        open(config) {
            console.log(2,config)
            if (config && Array.isArray(config.rows)) {
                this.rows = config.rows
            } else {
                this.rows = []
            }
            this.visible = true
        },
        handleClose() {
            this.rows = []
        },
        orderNumber(row) {
            return row.product_order?.number ?? row.product_order_number ?? '—'
        },
        handleOpenOrder(row) {
            const id =  row.product_order?.id
            if (id) {
                this.$emit('open-order', id)
            }
        },
        handleOpenSupplier(row) {
            const id = row.product?.supplier?.id
            if (id) {
                this.$emit('open-supplier', id)
            }
        },
        handleOpenProduct(row) {
            const id = row.product?.id
            if (id) {
                this.$emit('open-product', id)
            }
        },
    },
}
</script>
